// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2RLZ2","content":"LayoutSettings_content__1-iOF"};